import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchEmployeerComponent = createAsyncThunk("employeerComponent/fetchEmployeerComponent", async (search) => {
  const response = await api.post("/employee-component",{'search':search});
  return response.data.data;
});

export const addEmployeerComponent = createAsyncThunk(
  "employeerComponent/addEmployeerComponent",
  async (employeerComponentData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", employeerComponentData);
      dispatch(fetchEmployeerComponent());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deleteEmployeerComponent = createAsyncThunk(
  "employeerComponent/deleteEmployeerComponent",
  async (employeerComponentId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-employee/${employeerComponentId}`);
      dispatch(fetchEmployeerComponent());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const employeerComponentSlice = createSlice({
  name: "employeerComponentData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openEmployeerComponentModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeEmployeerComponentModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeerComponent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeerComponent.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmployeerComponent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEmployeerComponent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEmployeerComponent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addEmployeerComponent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmployeerComponent.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteEmployeerComponent.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteEmployeerComponent.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openEmployeerComponentModal, closeEmployeerComponentModal, clearError } = employeerComponentSlice.actions;
export default employeerComponentSlice.reducer;
export { employeerComponentSlice };